"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlashsalesSetStockCache = exports.FlashsalesGetStockCache = exports.GetAppTopProductGpids = exports.FlashsalesGetSettingsInfo = exports.FlashsalesGetProductInfo = exports.GetSellerCostPrice = exports.UserSetProductsRemind = exports.UserGetFlashsalesProductByCategories = exports.UserGetFlashSalesListByDate = exports.UserGetHomeFlashSalesProducts = exports.AdminSetTopOrDownProducts = exports.AdminSetAppTopProductGpids = exports.AdminEditProductsSequence = exports.AdminDeleteCategory = exports.AdminUpdateCategory = exports.AdminGetCategory = exports.AdminAddCategory = exports.AdminExportProducts = exports.AdminGetProductItem = exports.AdminUploadFlashsalesProducts = exports.AdminGetProductByCondition = exports.AdminSetProductSortBySales = exports.AdminGetFlashsalesProducts = exports.AdminDeleteFlashsalesProducts = exports.AdminUpdateFlashsalesProducts = exports.AdminAddProducts = exports.AdminGetFlashsalesSettings = exports.AdminSyncFlashSalesSetting = exports.AdminDeleteFlashsalesSetting = exports.AdminUpdateFlashsalesSetting = exports.AdminAddFlashsalesSetting = exports.GetFlashSalesListByCategories = exports.PutBackFlashsalesProductStock = exports.CheckFlashsalesProductValid = exports.AddCoustomerBuyFlashsalesProductCount = exports.FlashsalesGetCheckoutInfo = exports.FlashsalesMakeCheckout = exports.GetFlashsaleProductDetail = exports.GetProductsFlashsalesDetail = exports.GetProductDetail = exports.FlashsalesCacheType = exports.ErrorCode = void 0;
var webapi_1 = require("../webapi");
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["OK"] = "OK";
    ErrorCode["NotFound"] = "NotFound";
    ErrorCode["Unkonwn"] = "Unkonwn";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
var FlashsalesCacheType;
(function (FlashsalesCacheType) {
    FlashsalesCacheType["SettingCache"] = "SettingCache";
    FlashsalesCacheType["ProductSCache"] = "ProductSCache";
    FlashsalesCacheType["SoldStockCache"] = "SoldStockCache";
    FlashsalesCacheType["TotalStockCache"] = "TotalStockCache";
    FlashsalesCacheType["IsSortCache"] = "IsSortCache";
})(FlashsalesCacheType = exports.FlashsalesCacheType || (exports.FlashsalesCacheType = {}));
function GetProductDetail(payload) {
    return webapi_1.default("flashsales.FlashSales/GetProductDetail", payload);
}
exports.GetProductDetail = GetProductDetail;
function GetProductsFlashsalesDetail(payload) {
    return webapi_1.default("flashsales.FlashSales/GetProductsFlashsalesDetail", payload);
}
exports.GetProductsFlashsalesDetail = GetProductsFlashsalesDetail;
function GetFlashsaleProductDetail(payload) {
    return webapi_1.default("flashsales.FlashSales/GetFlashsaleProductDetail", payload);
}
exports.GetFlashsaleProductDetail = GetFlashsaleProductDetail;
function FlashsalesMakeCheckout(payload) {
    return webapi_1.default("flashsales.FlashSales/FlashsalesMakeCheckout", payload);
}
exports.FlashsalesMakeCheckout = FlashsalesMakeCheckout;
function FlashsalesGetCheckoutInfo(payload) {
    return webapi_1.default("flashsales.FlashSales/FlashsalesGetCheckoutInfo", payload);
}
exports.FlashsalesGetCheckoutInfo = FlashsalesGetCheckoutInfo;
function AddCoustomerBuyFlashsalesProductCount(payload) {
    return webapi_1.default("flashsales.FlashSales/AddCoustomerBuyFlashsalesProductCount", payload);
}
exports.AddCoustomerBuyFlashsalesProductCount = AddCoustomerBuyFlashsalesProductCount;
function CheckFlashsalesProductValid(payload) {
    return webapi_1.default("flashsales.FlashSales/CheckFlashsalesProductValid", payload);
}
exports.CheckFlashsalesProductValid = CheckFlashsalesProductValid;
function PutBackFlashsalesProductStock(payload) {
    return webapi_1.default("flashsales.FlashSales/PutBackFlashsalesProductStock", payload);
}
exports.PutBackFlashsalesProductStock = PutBackFlashsalesProductStock;
function GetFlashSalesListByCategories(payload) {
    return webapi_1.default("flashsales.FlashSales/GetFlashSalesListByCategories", payload);
}
exports.GetFlashSalesListByCategories = GetFlashSalesListByCategories;
function AdminAddFlashsalesSetting(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminAddFlashsalesSetting", payload);
}
exports.AdminAddFlashsalesSetting = AdminAddFlashsalesSetting;
function AdminUpdateFlashsalesSetting(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminUpdateFlashsalesSetting", payload);
}
exports.AdminUpdateFlashsalesSetting = AdminUpdateFlashsalesSetting;
function AdminDeleteFlashsalesSetting(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminDeleteFlashsalesSetting", payload);
}
exports.AdminDeleteFlashsalesSetting = AdminDeleteFlashsalesSetting;
function AdminSyncFlashSalesSetting(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminSyncFlashSalesSetting", payload);
}
exports.AdminSyncFlashSalesSetting = AdminSyncFlashSalesSetting;
function AdminGetFlashsalesSettings(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminGetFlashsalesSettings", payload);
}
exports.AdminGetFlashsalesSettings = AdminGetFlashsalesSettings;
function AdminAddProducts(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminAddProducts", payload);
}
exports.AdminAddProducts = AdminAddProducts;
function AdminUpdateFlashsalesProducts(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminUpdateFlashsalesProducts", payload);
}
exports.AdminUpdateFlashsalesProducts = AdminUpdateFlashsalesProducts;
function AdminDeleteFlashsalesProducts(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminDeleteFlashsalesProducts", payload);
}
exports.AdminDeleteFlashsalesProducts = AdminDeleteFlashsalesProducts;
function AdminGetFlashsalesProducts(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminGetFlashsalesProducts", payload);
}
exports.AdminGetFlashsalesProducts = AdminGetFlashsalesProducts;
function AdminSetProductSortBySales(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminSetProductSortBySales", payload);
}
exports.AdminSetProductSortBySales = AdminSetProductSortBySales;
function AdminGetProductByCondition(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminGetProductByCondition", payload);
}
exports.AdminGetProductByCondition = AdminGetProductByCondition;
function AdminUploadFlashsalesProducts(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminUploadFlashsalesProducts", payload);
}
exports.AdminUploadFlashsalesProducts = AdminUploadFlashsalesProducts;
function AdminGetProductItem(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminGetProductItem", payload);
}
exports.AdminGetProductItem = AdminGetProductItem;
function AdminExportProducts(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminExportProducts", payload);
}
exports.AdminExportProducts = AdminExportProducts;
function AdminAddCategory(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminAddCategory", payload);
}
exports.AdminAddCategory = AdminAddCategory;
function AdminGetCategory(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminGetCategory", payload);
}
exports.AdminGetCategory = AdminGetCategory;
function AdminUpdateCategory(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminUpdateCategory", payload);
}
exports.AdminUpdateCategory = AdminUpdateCategory;
function AdminDeleteCategory(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminDeleteCategory", payload);
}
exports.AdminDeleteCategory = AdminDeleteCategory;
function AdminEditProductsSequence(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminEditProductsSequence", payload);
}
exports.AdminEditProductsSequence = AdminEditProductsSequence;
function AdminSetAppTopProductGpids(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminSetAppTopProductGpids", payload);
}
exports.AdminSetAppTopProductGpids = AdminSetAppTopProductGpids;
function AdminSetTopOrDownProducts(payload) {
    return webapi_1.default("flashsales.FlashSales/AdminSetTopOrDownProducts", payload);
}
exports.AdminSetTopOrDownProducts = AdminSetTopOrDownProducts;
function UserGetHomeFlashSalesProducts(payload) {
    return webapi_1.default("flashsales.FlashSales/UserGetHomeFlashSalesProducts", payload);
}
exports.UserGetHomeFlashSalesProducts = UserGetHomeFlashSalesProducts;
function UserGetFlashSalesListByDate(payload) {
    return webapi_1.default("flashsales.FlashSales/UserGetFlashSalesListByDate", payload);
}
exports.UserGetFlashSalesListByDate = UserGetFlashSalesListByDate;
function UserGetFlashsalesProductByCategories(payload) {
    return webapi_1.default("flashsales.FlashSales/UserGetFlashsalesProductByCategories", payload);
}
exports.UserGetFlashsalesProductByCategories = UserGetFlashsalesProductByCategories;
function UserSetProductsRemind(payload) {
    return webapi_1.default("flashsales.FlashSales/UserSetProductsRemind", payload);
}
exports.UserSetProductsRemind = UserSetProductsRemind;
function GetSellerCostPrice(payload) {
    return webapi_1.default("flashsales.FlashSales/GetSellerCostPrice", payload);
}
exports.GetSellerCostPrice = GetSellerCostPrice;
function FlashsalesGetProductInfo(payload) {
    return webapi_1.default("flashsales.FlashSales/FlashsalesGetProductInfo", payload);
}
exports.FlashsalesGetProductInfo = FlashsalesGetProductInfo;
function FlashsalesGetSettingsInfo(payload) {
    return webapi_1.default("flashsales.FlashSales/FlashsalesGetSettingsInfo", payload);
}
exports.FlashsalesGetSettingsInfo = FlashsalesGetSettingsInfo;
function GetAppTopProductGpids(payload) {
    return webapi_1.default("flashsales.FlashSales/GetAppTopProductGpids", payload);
}
exports.GetAppTopProductGpids = GetAppTopProductGpids;
function FlashsalesGetStockCache(payload) {
    return webapi_1.default("flashsales.FlashSales/FlashsalesGetStockCache", payload);
}
exports.FlashsalesGetStockCache = FlashsalesGetStockCache;
function FlashsalesSetStockCache(payload) {
    return webapi_1.default("flashsales.FlashSales/FlashsalesSetStockCache", payload);
}
exports.FlashsalesSetStockCache = FlashsalesSetStockCache;
exports.default = {
    GetProductDetail: GetProductDetail,
    GetProductsFlashsalesDetail: GetProductsFlashsalesDetail,
    GetFlashsaleProductDetail: GetFlashsaleProductDetail,
    FlashsalesMakeCheckout: FlashsalesMakeCheckout,
    FlashsalesGetCheckoutInfo: FlashsalesGetCheckoutInfo,
    AddCoustomerBuyFlashsalesProductCount: AddCoustomerBuyFlashsalesProductCount,
    CheckFlashsalesProductValid: CheckFlashsalesProductValid,
    PutBackFlashsalesProductStock: PutBackFlashsalesProductStock,
    GetFlashSalesListByCategories: GetFlashSalesListByCategories,
    AdminAddFlashsalesSetting: AdminAddFlashsalesSetting,
    AdminUpdateFlashsalesSetting: AdminUpdateFlashsalesSetting,
    AdminDeleteFlashsalesSetting: AdminDeleteFlashsalesSetting,
    AdminSyncFlashSalesSetting: AdminSyncFlashSalesSetting,
    AdminGetFlashsalesSettings: AdminGetFlashsalesSettings,
    AdminAddProducts: AdminAddProducts,
    AdminUpdateFlashsalesProducts: AdminUpdateFlashsalesProducts,
    AdminDeleteFlashsalesProducts: AdminDeleteFlashsalesProducts,
    AdminGetFlashsalesProducts: AdminGetFlashsalesProducts,
    AdminSetProductSortBySales: AdminSetProductSortBySales,
    AdminGetProductByCondition: AdminGetProductByCondition,
    AdminUploadFlashsalesProducts: AdminUploadFlashsalesProducts,
    AdminGetProductItem: AdminGetProductItem,
    AdminExportProducts: AdminExportProducts,
    AdminAddCategory: AdminAddCategory,
    AdminGetCategory: AdminGetCategory,
    AdminUpdateCategory: AdminUpdateCategory,
    AdminDeleteCategory: AdminDeleteCategory,
    AdminEditProductsSequence: AdminEditProductsSequence,
    AdminSetAppTopProductGpids: AdminSetAppTopProductGpids,
    AdminSetTopOrDownProducts: AdminSetTopOrDownProducts,
    UserGetHomeFlashSalesProducts: UserGetHomeFlashSalesProducts,
    UserGetFlashSalesListByDate: UserGetFlashSalesListByDate,
    UserGetFlashsalesProductByCategories: UserGetFlashsalesProductByCategories,
    UserSetProductsRemind: UserSetProductsRemind,
    GetSellerCostPrice: GetSellerCostPrice,
    FlashsalesGetProductInfo: FlashsalesGetProductInfo,
    FlashsalesGetSettingsInfo: FlashsalesGetSettingsInfo,
    GetAppTopProductGpids: GetAppTopProductGpids,
    FlashsalesGetStockCache: FlashsalesGetStockCache,
    FlashsalesSetStockCache: FlashsalesSetStockCache
};
